import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import styles from './ItemRule.css';
import ItemInput from './ItemInput';

class ItemInputList extends Component {
  render() {
    const {
      items,
      itemVariants,
      earningRuleItems,
      buildOptions,
      onSelectItem,
      onSelectItemVariant,
      removeItem,
      addItem,
    } = this.props;
    if (
      earningRuleItems === undefined ||
      earningRuleItems === null ||
      (earningRuleItems && earningRuleItems.length === 0)
    ) {
      const earningRuleItem = {
        item_name: null,
        category_name: null,
        item_variant_names: [],
        type: 'ITEM',
      };
      this.props.addNewItem(earningRuleItem);
    }
    return (
      <div>
        {earningRuleItems.map((earningRuleItem, itemIndex) => (
          <ItemInput
            key={itemIndex}
            items={setItemOptions(items, earningRuleItems, earningRuleItem)}
            itemVariants={itemVariants}
            buildOptions={buildOptions}
            itemIndex={itemIndex}
            earningRuleItem={earningRuleItem}
            onChangeItem={selectedItem => onSelectItem(itemIndex, selectedItem)}
            onChangeItemVariant={selectedItemVariants =>
              onSelectItemVariant(itemIndex, selectedItemVariants)
            }
            removeItem={removeItem}
          />
        ))}
        <button
          type="submit"
          className={`btn btn-primary ${styles['btn-add-item']}`}
          onClick={addItem}
          disabled={
            items.length === earningRuleItems.length ||
            _.find(earningRuleItems, { item_name: null })
          }
        >
          Add More Items
        </button>
      </div>
    );
  }
}

ItemInputList.propTypes = {
  items: PropTypes.array.isRequired,
  buildOptions: PropTypes.func.isRequired,
  earningRuleItems: PropTypes.array.isRequired,
  onSelectItem: PropTypes.func.isRequired,
  onSelectItemVariant: PropTypes.func.isRequired,
};

const setItemOptions = (items, earningRuleItems, earningRuleItem) => {
  const diff = _.difference(items, earningRuleItems.map(x => x.item_name));
  return earningRuleItem.item_name
    ? diff.concat(earningRuleItem.item_name)
    : diff;
};

export default ItemInputList;
